import React from 'react';
import './Loader.scss';

type LoaderProps = {
    isLoading: boolean;
}

export const Loader: React.FC<LoaderProps> = ({isLoading}) => {
    return (
        <div style={{ display: isLoading ? 'flex' : 'none' }} className="loader-block">
            <div className="loader" id="loader-4">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    );
}